module.exports = __webpack_public_path__ + "static/media/ncd.8a7e3fd7.png";